// @flow

import React from 'react';
import { Card, Message } from 'semantic-ui-react';
import ResourceItem from './ResourceItem';

type Props = {
  resources: List<BucketResource>,
  isCreating: boolean,
  onSelect: (resource: BucketResource) => void,
};

const ResourcesPage = ({ resources, isCreating, onSelect }: Props) => {
  if (resources && resources.size) {
    return (
      <Card.Group itemsPerRow={6}>
        {resources.map(r => (
          <ResourceItem
            key={r.id}
            resource={r}
            isCreating={isCreating}
            onSelect={onSelect}
          />
        ))}
      </Card.Group>
    );
  }

  return (
    <Message
      icon="info"
      header="Aucune ressource ne correspond aux critères demandés"
    />
  );
};

export default ResourcesPage;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/components/ResourcesPage.js